import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  AppEvent,
  CreateEventDto,
  Recommandation,
} from '../models/event.model';
import { RouteResult } from '../models/location.models';
import { EventRefreshService } from './event-refresh.service';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  private apiUrl = `${environment.apiUrl}/events`;

  constructor(
    private http: HttpClient,
    private refreshService: EventRefreshService,
  ) {}

  getEvents(params?: any): Observable<AppEvent[]> {
    return this.http.get<AppEvent[]>(this.apiUrl, { params });
  }

  getEvent(id: string): Observable<AppEvent> {
    return this.http.get<AppEvent>(`${this.apiUrl}/${id}`);
  }

  createEvent(data: CreateEventDto): Observable<AppEvent> {
    return this.http
      .post<AppEvent>(this.apiUrl, data)
      .pipe(tap(() => this.refreshService.trigger()));
  }

  updateEvent(id: string, data: Partial<CreateEventDto>): Observable<AppEvent> {
    return this.http
      .put<AppEvent>(`${this.apiUrl}/${id}`, data)
      .pipe(tap(() => this.refreshService.trigger()));
  }

  /** Patch only location.routeData — fire-and-forget safe */
  patchRouteData(
    id: string,
    routeData: RouteResult,
  ): Observable<{ success: boolean }> {
    return this.http.patch<{ success: boolean }>(
      `${this.apiUrl}/${id}/route-data`,
      routeData,
    );
  }

  deleteEvent(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  duplicateEvent(id: string): Observable<AppEvent> {
    return this.http
      .post<AppEvent>(`${this.apiUrl}/${id}/duplicate`, {})
      .pipe(tap(() => this.refreshService.trigger()));
  }

  getRecommandations(eventId: string): Observable<Recommandation[]> {
    return this.http.get<Recommandation[]>(
      `${this.apiUrl}/${eventId}/recommandation`,
    );
  }
}
